import React, { useContext } from 'react';
import StoreContext from '../../context/StoreContext';
import { LineItem } from '.';
import { getPrice } from '../../util/helpers';
import './CartContents.scss';

const CartContents = (props) => {
  const {
    closeMinicart,
  } = props;
  const context = useContext(StoreContext);
  const { checkout, fetching } = context;
  const {
    lineItems,
    subtotalPrice,
    webUrl,
  } = checkout;
  let totalQuantity = 0;
  lineItems.forEach((lineItem) => {
    totalQuantity += lineItem.quantity;
  });
  return (
    <div className="cart-contents">
      <div className="cart-title">
        <h2>
          Your Cart
          {!fetching && (<span className="qty-count">{`(${totalQuantity})`}</span>)}
        </h2>
        <button
          type="button"
          onClick={event => closeMinicart(event)}
          className="close-minicart-button"
          aria-label="Close the Cart"
        >
          <div className="icon">
            <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
              <g
                stroke="#FFFFF4"
                strokeWidth="2"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
              >
                <path d="M1 1c.887 1.384 2.523 3.27 4.909 5.655 2.385 2.386 6.254 6.006 11.605 10.86" />
                <path d="M17.514 1c-.89.8-2.268 2.135-4.137 4.004-1.241 1.241-3.474 4.08-6.708 7.354C5.579 13.46 3.69 15.179 1 17.514" />
              </g>
            </svg>
          </div>
        </button>
      </div>
      { fetching ? (
        <div className="loading-message">
          <span>Fetching your cart items</span>
        </div>
      ) : (
        <>
          {totalQuantity > 0 ? (
            <>
              <ul className="line-items">
                {lineItems.map(lineItem => (
                  <LineItem
                    key={lineItem.id}
                    lineItem={lineItem}
                  />
                ))}
              </ul>
              <div className="subtotal">
                <h3>Subtotal</h3>
                <span className="subtotal-cost">{getPrice(subtotalPrice)}</span>
              </div>
            </>
          ) : (
            <p className="empty-cart-message">
              <span className="title">Your shopping cart is empty.</span>
              <span className="subtitle">When you add items to your cart, they will appear here.</span>
            </p>
          )}
          <div className="cart-actions">
            {totalQuantity > 0 && (
              <a
                className="checkout-button alt-styled-button"
                href={webUrl}
                aria-label="Continue to checkout, and purchase the contents of your cart"
              >
                <span>Continue to Checkout</span>
              </a>
            )}
            <button
              type="button"
              onClick={event => closeMinicart(event)}
              className="keep-shopping-button alt-styled-button"
              aria-label="Close the Cart"
            >
              <span>Keep Shopping</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartContents;
